export const emailChecker= (email: string) => {
    const trimmedEmail = email.trim();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (emailRegex.test(trimmedEmail)) {
        return trimmedEmail; 
    }

    return null; 
};

